/**
 * The look hint, bottom-right.  context.js writes its three sentences
 * (locked / drag / touch) and toggles it with the game's started state.
 */
import "./lookhint.css";
import { mount } from "./dom.js";

export function mountLookHint() {
  return mount(`
<div id="look-hint" class="panel hidden">right-drag to look around</div>`);
}
